import AbstractVertical from './AbstractVertical'

export default class Transient extends AbstractVertical {

  readonly name: string = 'spothero_in_out'
  readonly title: string = 'SpotHero In & Out'
  readonly color: string = '#cc7800' // not part of the accessible palette we've been using, but we're out of colors
  readonly sortWeight: number = 80

  readonly supportedFeatures: string[] = [
    'showOnRateManagementCalendar',
    'limitedByWeekday',
    'showOnUniversalInventoryCalendar',
    'spotRates',
    'startAndEndTimes',
    'tieredRates',
  ]

}
